import { ValidationErrors, AbstractControl } from '@angular/forms';
import { CONSTANTS } from 'src/app/shared/enums/index.enum';
import * as moment from 'moment';

export function splitNRIC(value) {
  const regex = /^(\d{2})(\d{2})(\d{2})-?(\d{2})-?(\d{3})(\d{1})$/;
  const parts = value.match(regex);

  if (!parts) {
    throw new Error('Invalid value number format');
  }

  return parts;
}


export function combineToDate(year, month, day) {
  const today = new Date();
  const combinedDate = new Date(year, month - 1, day);

  const age = today.getFullYear() - combinedDate.getFullYear();

  // Works for now. Update this in year 2099.
  if (age > 100 || (age == 100 && dateIsBefore(combinedDate, today))) {
    combinedDate.setFullYear(combinedDate.getFullYear() + 100);
  }

  return combinedDate;
}

function dateIsBefore(before, max) {
  const bNorm = new Date(0, before.getMonth(), before.getDate());
  const mNorm = new Date(0, max.getMonth(), max.getDate());

  return bNorm < mNorm;
}

export function inBetween(value, min, max) {
  return value >= min && value <= max;
}

export const RegexTinNo = '^[a-zA-Z0-9]{1,13}$';
export const RegexEmail = new RegExp("^(?=.{1,100}$)(?=.{1,64}@)[A-Za-z0-9!#$%&'*+/=?^_{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_{|}~-]+)*@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}|\\[(?:IPv6:[A-F0-9]{0,4}(?::[A-F0-9]{0,4}){2,7}|(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))\\])$", 'i');

export function splitBRNO(value) {
  const regex = /^(\d{4})(\d{2})(\d{6})$/;
  const parts = value.match(regex);

  if (!parts) {
    throw new Error('Invalid value number format');
  }

  return parts;
}

export function maxYearValue(value, max) {
  return value <= max;
}

export function recalculateNRICDriverAge(driverId) {
    const todayDate = new Date();
    const [input, year, month, day, birthPlace, ...rest] = splitNRIC(driverId);
    const driverBirthDate = combineToDate(year, month, day);
    let driverAge = todayDate.getFullYear() - driverBirthDate.getFullYear();

    // if (proposalDate) {
    //   driverAge = new Date(proposalDate).getFullYear() - driverBirthDate.getFullYear();
    // } else if (cnoteDate) {
    //   driverAge = new Date(cnoteDate).getFullYear() - driverBirthDate.getFullYear();
    // } else {
    //   driverAge = todayDate.getFullYear() - driverBirthDate.getFullYear();
    // }

  return driverAge;
}